const java = require('@/assets/imgs/java_256.png')
const spring = require('@/assets/imgs/spring_256.png')
const maven = require('@/assets/imgs/maven_256.png')
const mongo = require('@/assets/imgs/mongo2_256.png')
const solr = require('@/assets/imgs/solr_256.png')
const html5 = require('@/assets/imgs/html5_256.png')
const css3 = require('@/assets/imgs/css3_256.png')
const js = require('@/assets/imgs/js_256.png')
const vuejs = require('@/assets/imgs/vuejs_256.png')
const golang = require('@/assets/imgs/golang_256.png')
const elasticsearch = require('@/assets/imgs/es_256.png')
const graphql = require('@/assets/imgs/graphql_256.png')
const grpc = require('@/assets/imgs/grpc_256.png')
const kubernetes = require('@/assets/imgs/kub_256.png')
const docker = require('@/assets/imgs/docker_256.png')
const fr = require('@/assets/imgs/fr_256.png')
const en = require('@/assets/imgs/en_256.png')

const tf1 = require('@/assets/imgs/logo_tf1.png')
const sfr = require('@/assets/imgs/logo_sfr.png')
const orange = require('@/assets/imgs/logo_orange.png')
const alstom = require('@/assets/imgs/logo_alstom.png')
const accenture = require('@/assets/imgs/logo_accenture.png')
const ustl = require('@/assets/imgs/logo_ustl2.png')

const assets = {
  java: java,
  golang: golang,
  spring: spring,
  maven: maven,
  mongo: mongo,
  solr: solr,
  grpc: grpc,
  graphql: graphql,
  elasticsearch: elasticsearch,
  kubernetes: kubernetes,
  docker: docker,
  html5: html5,
  css3: css3,
  js: js,
  vuejs: vuejs,
  fr: fr,
  en: en,
  tf1: tf1,
  sfr: sfr,
  orange: orange,
  alstom: alstom,
  accenture: accenture,
  ustl: ustl
}

export default assets



// WEBPACK FOOTER //
// ./src/libs/assets.js